import React from "react";
import ReactWOW from "react-wow";

const Prizes = ({ Message: msg }) => (
  <section id="prizes" className="white">
    <div className="container">
      <div className="section-title">
        <h2>{msg.prizes}</h2>
        {/* <p>The Top 3 teams will win attractive cash prizes!</p> */}
      </div>
      <h3>{msg.prizesTitle1} </h3>
      <div className="flex-box jcc">
        {msg.prizesData.map(it => {
          return (
            <ReactWOW key={it.name} animation="fadeInUp" delay="0.1s">
              <div className="box box-3">
                <img src={it.image} alt="" className="img-prize" />
                <div className="content">
                  <strong className="name">{it.name}</strong>
                  <ul>
                    <li className="price">{it.price}</li>
                    {it.list.map(l => {
                      if (l === msg.prizesData[0].list[0]) {
                        return (
                          <li key={l} className="big">
                            {l}
                          </li>
                        );
                      }
                      return <li key={l}>{l}</li>;
                    })}
                  </ul>
                </div>
              </div>
            </ReactWOW>
          );
        })}
        {/* <ReactWOW animation="fadeInUp" delay="0.1s">
          <div className="box box-3">
            <img src="images/icon_reward.svg" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">The Winner</strong>
              <ul>
                <li className="price">40,000 THB/team plus Shopee Coins</li>
                <li>Return ticket to visit Shopee HQ office in Singapore</li>
                <li>Full-time / internship opportunities in Shopee</li>
              </ul>
            </div>
          </div>
        </ReactWOW> */}
        {/* <ReactWOW animation="fadeInUp" delay="0.2s">
          <div className="box box-3">
            <img src="images/prize-02.png" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">Second prize</strong>
              <ul>
                <li className="price">S$ 2,000</li>
                <li>Full-time / internship opportunities in Shopee</li>
              </ul>
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.3s">
          <div className="box box-3">
            <img src="images/prize-03.png" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">Third prize</strong>
              <ul>
                <li className="price">S$ 1,000</li>
                <li>Full-time / internship opportunities in Shopee</li>
              </ul>
            </div>
          </div>
        </ReactWOW> */}
      </div>
      <h3>{msg.prizesTitle2}</h3>
      <div className="flex-box">
        {msg.prizesData2.map(it => {
          return (
            <ReactWOW key={it.name} animation="fadeInUp" delay="0.1s">
              <div className="box box-3">
                <img src={it.image} alt="" className="img-prize" />
                <div className="content">
                  <strong className="name">{it.name}</strong>
                  <ul>
                    <li className="price">{it.price}</li>
                    {it.list.map(l => {
                      if (l === msg.prizesData[0].list[0]) {
                        return (
                          <li key={l} className="big">
                            {l}
                          </li>
                        );
                      }
                      return <li key={l}>{l}</li>;
                    })}
                  </ul>
                </div>
              </div>
            </ReactWOW>
          );
        })}
        {/* <ReactWOW animation="fadeInUp" delay="0.1s">
          <div className="box box-3">
            <img src="images/prize-01.png" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">First prize</strong>
              <ul>
                <li className="price">S$ 3,000</li>
                <li>Full-time / internship opportunities in Shopee</li>
              </ul>
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.2s">
          <div className="box box-3">
            <img src="images/prize-02.png" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">Second prize</strong>
              <ul>
                <li className="price">S$ 2,000</li>
                <li>Full-time / internship opportunities in Shopee</li>
              </ul>
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.3s">
          <div className="box box-3">
            <img src="images/prize-03.png" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">Third prize</strong>
              <ul>
                <li className="price">S$ 1,000</li>
                <li>Full-time / internship opportunities in Shopee</li>
              </ul>
            </div>
          </div>
        </ReactWOW> */}
      </div>
      <div className="section-footer">
        {/* <p>
          All participants will receive a certificate of accomplishment at the
          end of the competition only if their project has been submitted
          successfully before the deadline.
        </p> */}
        <p>{msg.prizesNote}</p>
        <p>{msg.prizesNote02}</p>
      </div>
    </div>
  </section>
);

export default Prizes;
